import { useQuery } from '@tanstack/react-query';
import { ImpersonationBroker, IOperationResult, UserSessionContext } from '../../extViewmodels';
import { UserTranscriptsResponse } from '../../extViewmodels/sdk/models/Zoom';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demos/user-transcripts';

type Params = {
	userId: string;
	startDate: string;
	endDate: string;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
	staleTime?: number;
};

const getQueryConfig = (userSession: UserSessionContext, params: Params) => {
	const { userId, startDate, endDate, enabled = true, ...queryParams } = params;
	return {
		queryKey: [BASE_QUERY_KEY, userId, startDate, endDate],
		queryFn: async () => {
			return new Promise<UserTranscriptsResponse>((resolve, reject) => {
				const queryString = new URLSearchParams({
					userId,
					startDate,
					endDate,
				}).toString();

				userSession.webServiceHelper.callWebServiceWithOperationResults<UserTranscriptsResponse>(
					ImpersonationBroker.composeApiUrl({
						urlPath: `lead/demos/transcripts?${queryString}`,
					}),
					'GET',
					null,
					(data: IOperationResult<UserTranscriptsResponse>) => {
						if (data.value) {
							resolve(data.value);
						} else {
							reject(new Error('No data returned from API'));
						}
					},
					reject
				);
			});
		},
		enabled,
		...queryParams,
	};
};

export function useUserTranscriptsQuery(params: Params) {
	const userSession = useUserSession();
	return useQuery(getQueryConfig(userSession, params));
}
